import { render, staticRenderFns } from "./CRMCustomer.vue?vue&type=template&id=76c126d8&scoped=true"
import script from "./CRMCustomer.vue?vue&type=script&lang=js"
export * from "./CRMCustomer.vue?vue&type=script&lang=js"
import style0 from "./CRMCustomer.vue?vue&type=style&index=0&id=76c126d8&prod&scoped=true&lang=css"
import style1 from "./CRMCustomer.vue?vue&type=style&index=1&id=76c126d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c126d8",
  null
  
)

export default component.exports